<template>
  <div>
    <form ref="fileform" v-on:click="clickOnContainer" v-bind:class="{
      'dragging': isDragging, 'simule position-relative': true,
      'not-selecting': enabled
    }">
      <div class="modal fade" id="shareModal" tabindex="-1" aria-labelledby="shareModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="shareModalLabel">Compartilhar</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fechar"></button>
            </div>
            <div class="modal-body">

              <div class="d-flex flex-row justify-content-center mb-4 ">


                <a v-bind:href="'https://wa.me/?text=Oi ! Olha que prática essa ferramenta ! Com ela eu consigo fazer uma simulação em vários ambientes utilizando os produtos IMAB.' +
                  ' ' +
                  ' '
                  + shareUrl" target="blank" rel="noopener noreferrer" class="text-gray me-4"><i
                    class="fab fa-whatsapp fa-4x"></i>
                </a>

                <a v-bind:href="'https://www.facebook.com/sharer.php?u=' + shareUrl + '&quote=Oi ! Olha que prática essa ferramenta ! Com ela eu consigo fazer uma simulação em vários ambientes utilizando os produtos IMAB.' +
                  '' +
                  ''
                  + shareUrl" target="blank" rel="noopener noreferrer" class="text-gray me-4"><i
                    class="fab fa-facebook fa-4x"></i>
                </a>

                <a v-bind:href="'https://twitter.com/intent/tweet?url=' + shareUrl + '&text=Oi ! Olha que prática essa ferramenta ! Com ela eu consigo fazer uma simulação em vários ambientes utilizando os produtos IMAB.'"
                  target="blank" rel="noopener noreferrer" class="text-gray me-4"><i
                    class="fab fa-twitter fa-4x"></i></a>

                <a v-bind:href="'https://www.linkedin.com/shareArticle?mini=true&url=' + shareUrl" target="blank"
                  rel="noopener noreferrer" class="text-gray"><i class="fab fa-linkedin fa-4x"></i></a>
              </div>
              <div class="input-group mb-3">

                <input type="text" class="form-control" readonly v-bind:value="shareUrl" placeholder=""
                  aria-label="Link para copiar e colar" aria-describedby="button-addon1">
                <button class="btn btn-outline-secondary" type="button" id="button-addon1" v-on:click="copyLink()">
                  Copiar
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!--    Aqui fica a simulação, a porta, a textura e acabamento aplicado-->
      <div class="simule-container" v-if="enabled">
        <!--          <canvas id="simulatorCanvas"></canvas>-->
        <div id="simulatorCanvas"></div>
        <!--        <div class="porta-container" v-if="step > 1" v-bind:style="{-->
        <!--        // 'width': this.doorSize.width + 'px',-->

        <!--        // 'right': this.doorSize.right + 'px'-->
        <!--      }">-->
        <!--          <div class="porta"></div>-->

        <!--          <div class="macaneta" v-bind:style="{-->
        <!--        'background-image' : finishingImagePath ? 'url(' + finishingImagePath + ')' : '',-->
        <!--        // 'width': this.doorSize.width + 'px',-->
        <!--        // 'height': this.doorSize.height + 'px',-->
        <!--      }">-->
        <!--            <img v-if="door"-->
        <!--                 v-bind:style="{-->
        <!--              // 'width': this.doorSize.width + 'px',-->
        <!--              // 'height': this.doorSize.height + 'px',-->
        <!--              '-webkit-mask-image' : finishing ? 'url(assets/upload/products/shadow/' + finishing.mask + ')' : '',-->
        <!--              'mask-image' : finishing ? 'url(assets/upload/products/shadow/' + finishing.mask + ')' : '',-->
        <!--              // 'mask-size' : this.doorSize.width + 'px ' + this.doorSize.height+'px',-->
        <!--              // '-webkit-mask-size' :this.doorSize.width + 'px ' + this.doorSize.height+'px',-->
        <!--              }"-->
        <!--                 v-bind:src="finishing ? 'assets/upload/products/img_large/'+finishing.file : null " alt="">-->
        <!--          </div>-->

        <!--          <div class="textura" v-bind:style="{-->
        <!--        'background-image' : textureImagePath ? 'url(' + textureImagePath + ')' : '',-->
        <!--         // 'width': this.doorSize.width + 'px',-->

        <!--      }"></div>-->

        <!--        </div>&lt;!&ndash;porta-container&ndash;&gt;-->


        <!--        <div id="ambienteDiv" class="ambiente"-->
        <!--             v-bind:style="{ 'background-image' : backgroundImagePath ? 'url(' + backgroundImagePath + ')' : '' }"></div>-->
        <img src="/images/simulator_title.png" alt="Simulador IMAB" class="simulator_title_mobile" v-if="enabled" />
      </div>
      <div class="simule-mask" v-if="step < 1" :class="{ 'enabled': this.enabled }">{{ step }}</div>

      <!--      <div class="d-flex flex-row">-->

      <div class="simule-tools-container" v-bind:class="{ 'is-selecting': enabled }">
        <div class="simule-buttons-container  d-flex justify-content-end" v-if="enabled && step === 5">
          <div class="btn-group" role="group" aria-label="Opções">

            <button class="btn btn-gold" type="button" v-on:click="shareLink">


              <!--            <span class="iconify fa-2x ms-1 me-1" data-icon="fa-brands:instagram-square"></span>-->
              <!--            <span class="iconify fa-2x me-1" data-icon="akar-icons:facebook-fill"></span>-->
              <span class="iconify fa-2x me-1" data-icon="ant-design:share-alt-outlined"></span>
              Compartilhar
              <!--            <span class="iconify fa-2x" data-icon="akar-icons:pinterest-fill"></span>-->
            </button>

            <button class="btn btn-silver" type="button" v-on:click="saveAsImage">
              <span class="iconify fa-2x" data-icon="ant-design:save-filled"></span> Salvar
            </button>

            <button class="btn btn-light-silver" type="button" v-on:click="buildCatalog">
              <span class="iconify fa-2x" data-icon="ps:facebook-places"></span> Crie seu Catálogo
            </button>
          </div>
        </div>
        <div class="text-white title mt-4" v-if="enabled == false"> Simule o ambiente</div>
        <div class="simule-tools  mt-md-4 py-4">
          <div class="row mx-auto">
            <div class="col simule-button" v-bind:class="{ 'active': (step === 1 || step === 0) && enabled }"
              v-on:click="goToStep(0)">
              <svg class="ambiente" id="noun_room_2076205" xmlns="http://www.w3.org/2000/svg" width="76.619"
                height="81.829" viewBox="0 0 76.619 81.829">
                <g id="Group_21" data-name="Group 21">
                  <g id="Group_20" data-name="Group 20">
                    <path id="Path_12" data-name="Path 12"
                      d="M76.374,22.067l-.336-.464L38.523,0h-.691L.346,21.594,0,22.13.245,59.408l.227.773L38.014,81.829h.691L76.374,60.117l.245-.791s0,.262-.06-9.053ZM38.4,38.532l5.455,3.128L38.4,44.779l-5.41-3.064Zm24.34,14.056-5.264,3-6.137-3.482,5.373-3.064Zm-30,2.728-6.01-3.4,5.455-3.1,6.01,3.437Zm5.874-2.846,5.583,3.164-5.455,3.091L33.15,55.562Zm-6.364,3.1L26.194,59.1l-6.01-3.437L26.258,52.2Zm.446.255,5.583,3.164L32.2,62.454,26.613,59.29Zm6.028,3.419,6.174,3.491L38.814,66.2l-6.137-3.464Zm.446-.255L44.615,55.9l6.137,3.482-5.455,3.1Zm5.874-3.355,5.783-3.3,6.146,3.482-5.783,3.3Zm5.819-3.81L45.27,48.661l5.455-3.091,5.537,3.182Zm-.446.255-5.783,3.3-5.583-3.164,5.783-3.3Zm-11.82-.118-6.01-3.41,5.783-3.3,6.01,3.41Zm-6.464-3.637L26.794,45.3,32.5,41.96l5.4,3.064Zm-.446.255L26.222,51.67l-5.264-2.982,5.41-3.119ZM25.8,51.934,19.73,55.4l-5.183-2.928,6-3.51Zm-6.519,3.728L13.829,58.79,8.7,55.889l5.41-3.155Zm.446.255,6.01,3.41-5.455,3.128-6.01-3.41Zm6.455,3.637,5.637,3.182-5.455,3.119L20.73,62.736Zm6.037,3.419,6.146,3.482-5.455,3.119-6.146-3.482Zm6.6,3.764,5.246,2.973-5.455,3.128-5.246-2.973Zm.446-.255,6.074-3.464,5.246,2.973-6.037,3.464Zm6.519-3.746,5.455-3.1,5.246,2.973L51.034,65.7Zm5.874-3.355,5.783-3.3L62.736,59.1l-5.783,3.3Zm6.228-3.555,5.255-3L68.3,55.853l-5.155,2.973ZM49.77,43.642V24.449l12.638,7.128Zm.473,1.7-5.455,3.091-6.01-3.4,5.455-3.119ZM1.491,22.458,37.678,1.546V37.223L10.7,52.9,1.609,58.08ZM7.546,62.39l-5-2.9,5.71-3.337,5.11,2.9-5.792,3.3A.363.363,0,0,1,7.546,62.39Zm6.364,3.7L7.956,62.636,13.8,59.3l6.028,3.437-5.874,3.355s-.018-.009-.027,0Zm.427.245,5.919-3.382,5.583,3.164-5.983,3.419ZM20.3,69.791l6.01-3.419,6.146,3.482-6.092,3.464Zm6.519,3.782,6.064-3.464,5.3,2.982-6.119,3.491Zm11.52,6.683-5.883-3.41,6.128-3.5L44.551,76.7Zm6.6-3.819-5.91-3.346,5.519-3.082,5.874,3.328Zm5.883-3.4-5.864-3.328,6.074-3.464,5.828,3.3Zm6.455-3.746-5.819-3.3,5.455-3.1,5.819,3.282Zm5.837-3.382-5.783-3.282,5.783-3.3,5.746,3.264Zm6.192-3.582L63.59,59.1l5.155-2.937,5.61,3.291Zm-6.3-11.092V31.386l-.173-.291L49.652,23.576l-.518.291V43.278L38.532,37.2V1.537L74.792,22.448l.191,35.632Z" />
                    <path id="Path_13" data-name="Path 13"
                      d="M72.894,36.324l4.2,2.473-4.2,1.637v-4.11m-.264-.464v4.728l4.737,2.782V38.642Z"
                      transform="translate(-6.594 -3.256)" />
                    <path id="Path_14" data-name="Path 14"
                      d="M46.173,22.313l4.2,2.473-4.2,1.637v-4.11m-.264-.464v4.682l4.737,2.791V24.595L45.9,21.84Z"
                      transform="translate(-4.167 -1.983)" />
                  </g>
                </g>
              </svg>

              <div class="simule-desc font-weight-bold">Ambiente</div>
            </div>
            <div class="col simule-button border-having" v-bind:class="{ 'active': step === 2 }" v-on:click="goToStep(2)">
              <svg id="noun_Door_4023647" xmlns="http://www.w3.org/2000/svg" width="64.055" height="63.783"
                viewBox="0 0 64.055 63.783">
                <path id="Path_15" data-name="Path 15"
                  d="M140.738,140.5h-7.243V78.867a.717.717,0,0,0-.717-.717h-46.7a.717.717,0,0,0-.717.717V140.5H78.117a.717.717,0,1,0,0,1.435h62.621a.717.717,0,1,0,0-1.435ZM86.8,79.588h45.256V140.5h-3.913V83.575a.63.63,0,0,0-.014-.131.111.111,0,0,0,0-.023.653.653,0,0,0-.036-.115l-.011-.025a.675.675,0,0,0-.057-.106l-.009-.013a.655.655,0,0,0-.072-.086l-.014-.016c-.023-.021-.047-.043-.072-.063l-.018-.011-.027-.018a.78.78,0,0,0-.1-.056h-.023a.618.618,0,0,0-.1-.031h-.029a.922.922,0,0,0-.12-.013H91.434a.717.717,0,0,0-.717.717V140.5H86.8Zm13.867,52.994V92.211L126.7,84.536v55.72ZM92.153,84.294h30.281l-22.69,6.687a.717.717,0,0,0-.516.69v41.449a.717.717,0,0,0,.516.69l22.69,6.687H92.153Z"
                  transform="translate(-77.4 -78.15)" />
                <path id="Path_16" data-name="Path 16"
                  d="M221.8,249.73a2.994,2.994,0,1,0,2.609,2.968A2.812,2.812,0,0,0,221.8,249.73Zm0,4.5a1.584,1.584,0,1,1,1.169-1.53A1.405,1.405,0,0,1,221.8,254.228Z"
                  transform="translate(-193.763 -218.961)" />
              </svg>

              <div class="simule-desc font-weight-bold">Porta</div>
            </div>
            <div class="col simule-button border-having" v-bind:class="{ 'active': step === 3 }" v-on:click="goToStep(3)">
              <svg id="noun_Door_Handle_961827" data-name="noun_Door Handle_961827" xmlns="http://www.w3.org/2000/svg"
                width="83.246" height="40.949" viewBox="0 0 83.246 40.949">
                <path id="Path_17" data-name="Path 17"
                  d="M97.46,36.342a.452.452,0,0,0-.041-.116c0-.009,0-.019-.009-.027s-.014-.014-.02-.022-.023-.03-.036-.046a.424.424,0,0,0-.045-.046.5.5,0,0,0-.049-.037c-.008,0-.013-.014-.021-.019l-5.008-2.9a.486.486,0,0,0-.057-.02.439.439,0,0,0-.086-.029A.467.467,0,0,0,92,33.071a.438.438,0,0,0-.087.006.45.45,0,0,0-.087.029.35.35,0,0,0-.058.02L54.072,54.893c-.008,0-.013.013-.021.019s-.031.023-.048.036a.434.434,0,0,0-.046.046.384.384,0,0,0-.037.049c0,.007-.013.012-.017.02s0,.017-.009.026a.439.439,0,0,0-.024.058.386.386,0,0,0-.017.063.48.48,0,0,0-.008.057c0,.012-.006.02-.006.029v.711l-5.41,3.111L39.46,53.95V37.281a.235.235,0,0,0-.006-.028.538.538,0,0,0-.008-.06.513.513,0,0,0-.016-.06.489.489,0,0,0-.024-.057c0-.009,0-.019-.009-.027s-.014-.014-.02-.022-.023-.03-.036-.046a.333.333,0,0,0-.045-.045.566.566,0,0,0-.05-.039c-.007,0-.012-.013-.02-.017L35.9,34.952a.488.488,0,0,0-.058-.02.446.446,0,0,0-.084-.029.428.428,0,0,0-.094-.006.391.391,0,0,0-.082.006.437.437,0,0,0-.091.03.349.349,0,0,0-.056.019L14.463,47.043c-.009,0-.014.014-.022.02a.394.394,0,0,0-.049.038.375.375,0,0,0-.043.043.426.426,0,0,0-.039.051c0,.008-.014.013-.019.022a.216.216,0,0,0-.008.026.548.548,0,0,0-.023.055.449.449,0,0,0-.017.065.5.5,0,0,0-.008.058.24.24,0,0,0-.006.028V71.633a.4.4,0,0,0,.013.06.394.394,0,0,0,.019.089.418.418,0,0,0,.039.079.434.434,0,0,0,.049.072.359.359,0,0,0,.071.062.375.375,0,0,0,.045.041l3.379,1.924h0c.007,0,.015,0,.022.006a.45.45,0,0,0,.208.055.456.456,0,0,0,.209-.056c.007,0,.016,0,.023-.007h0l14.42-8.334,13.377,7.731h0c.008,0,.017,0,.024.008a.423.423,0,0,0,.415,0,.2.2,0,0,0,.024-.008h0l11.907-6.881.6.352,0,0a.148.148,0,0,0,.024.008.424.424,0,0,0,.414,0c.008,0,.016,0,.024-.009h0l37.694-21.77a.432.432,0,0,0,.043-.038.522.522,0,0,0,.072-.063.489.489,0,0,0,.049-.072.38.38,0,0,0,.038-.079,7.3,7.3,0,0,0,.031-.149V36.432a.243.243,0,0,0-.006-.028C97.467,36.382,97.463,36.363,97.46,36.342ZM35.669,35.89l2.4,1.39L18.078,48.835l-2.444-1.394ZM48.2,60.054h0a.458.458,0,0,0,.461,0,0,0,0,0,1,0,0l5.874-3.377.015-.014s.008,0,.013,0l.151-.1,3.249,1.885L46.341,65.153,26.318,53.6l5.368-3.089,7.078,4.109h0ZM15.164,48.244l2.45,1.4V72.755l-2.45-1.394Zm3.379,1.395,19.99-11.554V53.41l-6.612-3.837c-.021-.012-.043-.013-.064-.022a.383.383,0,0,0-.078-.026.449.449,0,0,0-.1-.007.463.463,0,0,0-.08,0,.5.5,0,0,0-.092.03.3.3,0,0,0-.055.019l-6.3,3.624c-.009,0-.014.014-.022.019s-.032.024-.049.037a.429.429,0,0,0-.045.046.453.453,0,0,0-.036.046c-.006.008-.014.013-.02.022s0,.017-.009.026a.487.487,0,0,0-.023.057.524.524,0,0,0-.026.121.236.236,0,0,0-.006.028v7.262a15.272,15.272,0,0,1,.031.147.489.489,0,0,0,.039.082.412.412,0,0,0,.048.07.648.648,0,0,0,.072.066.426.426,0,0,0,.043.036L31.8,65.085,18.542,72.749V49.639Zm14.42,15.045h0l-7.111-4.092V54.4L45.877,65.958v6.19Zm13.842,1.274,11.62-6.709v6.179l-.181.109L46.807,72.147v-6.19Z"
                  transform="translate(-14.229 -33.071)" />
              </svg>

              <div class="simule-desc font-weight-bold">Maçaneta</div>
            </div>
            <div class="col simule-button border-having" v-bind:class="{ 'active': step === 4 }" v-on:click="goToStep(4)">
              <svg id="Group_23" data-name="Group 23" xmlns="http://www.w3.org/2000/svg" width="40.623" height="62.201"
                viewBox="0 0 40.623 62.201">
                <path id="Path_20" data-name="Path 20"
                  d="M25.087,77.737a.582.582,0,0,0,.031.147.816.816,0,0,0,.044.134c.007.015.005.029.015.042s.033.026.044.042a.725.725,0,0,0,.187.187.617.617,0,0,0,.077.051.726.726,0,0,0,.328.086h0l0,0a.725.725,0,0,0,.326-.086c.011-.007.024,0,.037-.011l6.617-3.812c.029-.015.046-.042.071-.06a.927.927,0,0,0,.11-.1.949.949,0,0,0,.064-.086c.007-.011.018-.015.026-.026s.007-.029.015-.04a.632.632,0,0,0,.037-.088.809.809,0,0,0,.027-.1.792.792,0,0,0,.013-.1c0-.015.009-.027.009-.04V50.966a.345.345,0,0,0-.009-.042.692.692,0,0,0-.029-.147.865.865,0,0,0-.046-.137c-.007-.013-.006-.029-.015-.042s-.042-.044-.06-.07a.944.944,0,0,0-.1-.112.816.816,0,0,0-.117-.079.566.566,0,0,0-.121-.059.78.78,0,0,0-.15-.031.745.745,0,0,0-.088-.018.353.353,0,0,0-.042.009.66.66,0,0,0-.143.029.886.886,0,0,0-.139.046c-.013.007-.029.006-.042.015l-3.942,2.28-.342.168-.029.026a.327.327,0,0,0-.038.015l-.489.309-1.774,1.014c-.027.016-.044.042-.07.06a.831.831,0,0,0-.114.1.667.667,0,0,0-.077.115.619.619,0,0,0-.06.121.84.84,0,0,0-.031.15.7.7,0,0,0-.018.09V77.693A.357.357,0,0,0,25.087,77.737Zm1.457-4.2,1.919-1.1,2.5,1.446-4.42,2.547Zm1.188-19.009v16.64l-1.188.681V55.2Z"
                  transform="translate(-6.385 -31.651)" />
                <path id="Path_21" data-name="Path 21"
                  d="M48.879,40.083l-33.551,19.3a.92.92,0,0,0-.458.795V98.331a.909.909,0,0,0,.458.793l5.279,3.038a.909.909,0,0,0,.458.123.933.933,0,0,0,.458-.123l33.06-19.053a.915.915,0,0,0,.458-.793l.452-38.077m-2.1,37.653L21.795,100.1V63.633L53.391,45.4ZM48.82,41.914l3.84,2.216-31.6,18.235-3.814-2.2Z"
                  transform="translate(-14.87 -40.083)" />
              </svg>

              <div class="simule-desc font-weight-bold">Acabamentos</div>
            </div>
          </div><!--row-->
        </div><!--simule-tools-->

        <div class="simule-tab simule-textura" v-bind:class="{ active: this.step !== 5 && this.enabled }">
          <VSlickCarousel @swipe="setCarouselSwiping(true)" @mouseup.native="setCarouselSwiping(false)"
            @touchend.native="setCarouselSwiping(false)" :class="{ '--swiping': swiping === true }" :arrows="false"
            v-if="enviroTypes.length && step === 0 && enabled" v-bind="slickSettings">
            <div v-for="enviroType in enviroTypes" :key="enviroType.id"
              class="simule-tab-item d-flex justify-content-center flex-column py-4"
              v-on:click="selectEnviroType(enviroType)">
              <div>
                <div class="tab-icon">
                  <img v-bind:src="'/images/simulator/' + enviroType.file" alt="">
                </div>
                <!--              <img v-bind:src="texture.file"/>-->
              </div>
              <div class="detail-view d-flex align-items-center justify-content-between">
                <div class="d-flex">
                  <div class="vertical-gold"></div>
                  <div class="pl-2">
                    <label class="site-font product-title">{{ enviroType.name }}</label>
                  </div>
                </div>
                <div>

                </div>
              </div>
            </div>

            <template #prevArrow="arrowSlotProps">
              <div @click="arrowSlotProps.onClick" class="slick-prev custom-prev">
                <span class="iconify arrowButton" data-icon="grommet-icons:form-previous"></span>
              </div>
            </template>
            <template #nextArrow="arrowSlotProps">
              <div @click="arrowSlotProps.onClick" class="slick-next custom-next">
                <span class="iconify arrowButton" data-icon="grommet-icons:form-next"></span>
              </div>
            </template>

          </VSlickCarousel>
          <!--        </div>-->

          <!--        <div class="simule-tab simule-textura">-->
          <VSlickCarousel @swipe="setCarouselSwiping(true)" @mouseup.native="setCarouselSwiping(false)"
            @touchend.native="setCarouselSwiping(false)" :class="{ '--swiping': swiping === true }"
            v-if="enviros.length && step === 1" v-bind="slickSettings">

            <div v-on:click="uploadEnviroImage" class="simule-tab-item d-flex justify-content-center flex-column py-4">
              <div>
                <div class="tab-icon">
                  <img src="images/simulator/upload_icon.png" alt="">
                </div>
                <!--              <img v-bind:src="texture.file"/>-->
              </div>
              <div class="detail-view d-flex align-items-center justify-content-between">
                <div class="d-flex">
                  <div class="vertical-gold"></div>
                  <div class="pl-2">
                    <label class="site-font product-title">SEU AMBIENTE</label>
                  </div>
                </div>
                <div>

                </div>
              </div>
            </div>


            <div v-for="enviro in enviros" :key="enviro.id"
              class="simule-tab-item d-flex justify-content-center flex-column py-4" v-on:click="selectEnviro(enviro)">
              <div>
                <div class="tab-image" v-bind:style="{ 'background-image': 'url(' + enviro.file + ')' }">

                </div>
                <!--              <img v-bind:src="texture.file"/>-->
              </div>
              <div class="detail-view d-flex align-items-center justify-content-between">
                <div class="d-flex">
                  <div class="vertical-gold"></div>
                  <div class="pl-2">
                    <label class="site-font product-title">{{ enviro.name }}</label>
                  </div>
                </div>
                <div>

                </div>
              </div>
            </div>


            <template #prevArrow="arrowSlotProps">
              <div @click="arrowSlotProps.onClick" :disabled="arrowSlotProps.disabled" class="slick-prev custom-prev">
                <span class="iconify arrowButton" data-icon="grommet-icons:form-previous"></span>
              </div>
            </template>
            <template #nextArrow="arrowSlotProps">
              <div @click="arrowSlotProps.onClick" :disabled="arrowSlotProps.disabled" class=" slick-next custom-next">
                <span class="iconify arrowButton" data-icon="grommet-icons:form-next"></span>
              </div>
            </template>

          </VSlickCarousel>
          <!--        </div>-->


          <!--        <div class="simule-tab simule-textura">-->
          <VSlickCarousel @swipe="setCarouselSwiping(true)" @mouseup.native="setCarouselSwiping(false)"
            @touchend.native="setCarouselSwiping(false)" :class="{ '--swiping': swiping === true }"
            v-if="textures.length && step === 2" v-bind="slickSettings" :key="refreshTextures">
            <div v-for="texture in textures" :key="texture.id"
              class="simule-tab-item d-flex justify-content-center flex-column py-4"
              v-on:click="selectTexture(texture)">
              <div>
                <div class="tab-image" v-bind:style="{ 'background-image': 'url(' + texture.file + ')' }">

                </div>
                <!--              <img v-bind:src="texture.file"/>-->
              </div>
              <div class="detail-view d-flex align-items-center justify-content-between">
                <div class="d-flex">
                  <div class="vertical-gold"></div>
                  <div class="pl-2">
                    <label class="site-font product-title">{{ texture.name }}</label>
                  </div>
                </div>
                <div>

                </div>
              </div>
            </div>

            <template #prevArrow="arrowSlotProps">
              <div @click="arrowSlotProps.onClick" class="slick-prev custom-prev">
                <span class="iconify arrowButton" data-icon="grommet-icons:form-previous"></span>
              </div>
            </template>
            <template #nextArrow="arrowSlotProps">
              <div @click="arrowSlotProps.onClick" class="slick-next custom-next">
                <span class="iconify arrowButton" data-icon="grommet-icons:form-next"></span>
              </div>
            </template>

          </VSlickCarousel>
          <!--        </div>-->

          <!--        <div class="simule-tab simule-produto" >-->
          <VSlickCarousel @swipe="setCarouselSwiping(true)" @mouseup.native="setCarouselSwiping(false)"
            @touchend.native="setCarouselSwiping(false)" :class="{ '--swiping': swiping === true }"
            v-if="products.length && step === 3" v-bind="slickSettings">
            <div v-for="product in products" :key="product.id"
              class="simule-tab-item d-flex justify-content-center flex-column py-4"
              v-on:click="selectProduct(product)">
              <!--            <div class="tab-image">-->
              <img class="tab-image" v-bind:src="'assets/upload/products/img_large/' + product.file" />

              <!--            </div>-->

              <!--            <div class="tab-image" v-bind:style="{'background-image': 'url(\'assets/upload/products/img_medium/' + product.file + ' \')' }">-->

              <!--            </div>-->


              <div class="detail-view d-flex align-items-center justify-content-between">
                <div class="d-flex">
                  <div class="vertical-gold"></div>
                  <div class="pl-2">
                    <label class="site-font product-title">{{ product.usu_modelo }}</label>
                  </div>
                </div>
                <div>

                </div>
              </div>
            </div>
            <template #prevArrow="arrowSlotProps">
              <div @click="arrowSlotProps.onClick" class="slick-prev custom-prev">
                <span class="iconify arrowButton" data-icon="grommet-icons:form-previous"></span>
              </div>
            </template>
            <template #nextArrow="arrowSlotProps">
              <div @click="arrowSlotProps.onClick" class="slick-next custom-next">
                <span class="iconify arrowButton" data-icon="grommet-icons:form-next"></span>
              </div>
            </template>
          </VSlickCarousel>
          <!--        </div>-->

          <!--        <div class="simule-tab simule-produto">-->
          <VSlickCarousel @swipe="setCarouselSwiping(true)" @mouseup.native="setCarouselSwiping(false)"
            @touchend.native="setCarouselSwiping(false)" :class="{ '--swiping': swiping === true }"
            v-if="finishings.length && step === 4" v-bind="slickSettings">
            <div v-for="finishing in finishings" :key="finishing.id"
              class="simule-tab-item d-flex justify-content-center flex-column py-4"
              v-on:click="selectFinishing(finishing)">

              <img class="tab-image" v-bind:src="'assets/upload/products/img_large/' + finishing.file" />

              <div class="detail-view d-flex align-items-center justify-content-between">
                <div class="d-flex">
                  <div class="vertical-gold"></div>
                  <div class="pl-2">
                    <label class="site-font product-title">{{ finishing.acab_descricao }}</label>
                  </div>
                </div>
                <div>

                </div>
              </div>
            </div>
            <template #prevArrow="arrowSlotProps">
              <div @click="arrowSlotProps.onClick" class="slick-prev custom-prev">
                <span class="iconify arrowButton" data-icon="grommet-icons:form-previous"></span>
              </div>
            </template>
            <template #nextArrow="arrowSlotProps">
              <div @click="arrowSlotProps.onClick" class="slick-next custom-next">
                <span class="iconify arrowButton" data-icon="grommet-icons:form-next"></span>
              </div>
            </template>

          </VSlickCarousel>
        </div>


        <!--      <label v-if="enabled && step == 1" class="btn btn-imab-gray drag-photo-btn">-->
        <!--        <i class="fas fa-cloud-upload-alt"></i>-->
        <!--        Arraste e envie a foto do seu ambiente aqui-->
        <input type="file" id="uploadFileInput" class="d-none" name="photo" v-on:willchange="backgroundWillChange"
          v-on:change="uploadImage">
        <!--      </label>-->


        <div class="product-bar d-none">
          <div
            class="product-bar-item col-12 col-sm-6 col-md-4 col-lg-3 d-flex justify-content-center flex-column py-4">
            <div>
              <img src="images/products-Interna/5.png'" />
            </div>
            <div class="detail-view d-flex align-items-center justify-content-between">
              <div class="d-flex">
                <div class="vertical"></div>
                <div class="pl-2">
                  <label class="site-font product-title">Bali</label>
                </div>
              </div>
              <div>

              </div>
            </div>
          </div>
        </div>

        <div class="gray-bar d-flex d-md-none align-content-around" v-if="enabled">
          <p>Bem-vindo ao <strong>SIMULADOR IMAB</strong>! <br><br>

            A IMAB tem uma novidade: agora você tem o SIMULADOR IMAB. Com várias combinações de fechaduras IMAB que
            complementam a porta, o Simulador disponibiliza diferentes ambientes e texturas de portas para uma simulação
            visual. Basta selecionar os itens no menu ao lado e, se quiser, você pode inserir uma imagem do seu próprio
            ambiente para ter a visualização da fechadura IMAB que mais combina com ele.

            <br> <br>

            E tem mais: você pode salvar a imagem da simulação e compartilhar o resultado no seu perfil do Facebook e do
            Instagram e, também, criar o catálogo do produto escolhido.

            <br> <br>
            Faça já sua simulação e descubra como ficou mais fácil acertar na escolha da sua fechadura IMAB e deixar seu
            ambiente muito mais harmonioso e seguro.

          </p>
        </div>

      </div>

      <!--        <div class="gray-bar" v-if="enabled">-->
      <!--          <p class="mb-0 mt-0">-->
      <!--            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's-->
      <!--            standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make-->
      <!--            a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting,-->
      <!--            remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing-->
      <!--            Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions-->
      <!--            of Lorem Ip-->
      <!--          </p>-->
      <!--        </div>-->
      <!--      </div>&lt;!&ndash;container&ndash;&gt;-->


      <img src="/images/simulator_title.png" alt="Simulador IMAB" class="simulator_title" v-if="enabled" />
    </form>

  </div>
</template>

<script>
import Simulator from "../simulator";
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
// optional style for arrows & dots
// import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import html2canvas from 'html2canvas';
import computedStyleToInlineStyle from "computed-style-to-inline-style";

const axios = require('axios')
const konva = require('konva')

// $(document).on('change', '.select-image', function (e) {
//     if (typeof FileReader === "function") {
//         const imageFile = e.target.files[0]
//         let reader = new FileReader()
//
//         if (imageFile.type.includes("image/")) {
//             reader.readAsDataURL(imageFile)
//             reader.onload = event => {
//                 $(this).parent().css({
//                     backgroundImage: `url(${event.target.result})`,
//                 })
//             }
//         }
//     }
// })

import 'v-slick-carousel/style.css'
import { VSlickCarousel } from 'v-slick-carousel'

export default {
  components: { VSlickCarousel },
  data: function () {
    return {
      swiping: false,
      backgroundImagePath: null,
      textureImagePath: null,
      finishingImagePath: null,
      isDragging: false,
      dragAndDropCapable: false,
      step: 0,
      slickSettings: {
        
        // "dots": false,
        // "dotsClass": "slick-dots custom-dot-class",
        "edgeFriction": 0.35,
        "infinite": false,
        // "lazyLoad": "ondemand",
        "speed": 500,
        "groupsToShow": 5,
        "groupsToScroll": 1,
        "slidesPerGroup": 1,
        "responsive": [
          {
            "breakpoint": 900,
            "settings": {
              "groupsToShow": 4,
              "groupsToScroll": 1,
              "slidesPerGroup": 1,
            }
          },

          {
            "breakpoint": 450,
            "settings": {
              "groupsToShow": 3,
              "groupsToScroll": 1,
              "slidesPerGroup": 1,
            }
          },
        ]
      },
      enviroType: null,
      enviroTypes: [
        {
          id: 'INTERNO',
          name: 'Interno',
          file: 'interno_icon.svg',
        },
        {
          id: 'EXTERNO',
          name: 'Externo',
          file: 'externo_icon.svg',
        },
        {
          id: 'BANHEIRO',
          name: 'Banheiro',
          file: 'banheiro_icon.svg'
        }

      ],
      enviros: [],
      enviro: null,
      products: [],
      finishings: [],
      textures: [],
      refreshTextures: 0,
      finishing: null,
      product: null,
      canvas: null,
      door: {
        image: null
      },
      texture: null,
      originalWidth: 533,
      originalHeight: 400,
      screenWidth: 533,
      screenHeight: 400,
      doorSize: {
        width: 507,
        height: (400 * 507) / 388,
        right: -10
      },
      shareUrl: '',
      stage: null, //Simulator,
      stageKonva: {

        ambiente: null,
        enviro: null,
        porta: null,
        textura: null,
        macaneta: null,
        mascara: null,
        sombra: null,
        acabamento: null,
        imageObjects: [],
        stageHeight: null,
        stageWidth: null,

        layerSombra: null,
        layerPorta: null,
        layerBg: null,
        groupMacaneta: null,
        frames: 0
      }
    }
  },
  props: {
    enabled: Boolean,
    file: null,
    options: null,
  },
  computed: {
    preparedOptions: function () {
      return JSON.parse(this.options)
    }
  },
  created() {
    // window.addEventListener("resize", this.onResizeHandler)
  },
  destroyed() {
    // window.removeEventListener("resize", this.onResizeHandler)
  },
  async mounted() {
    console.log('this mounted', this.enabled)

    //Carregar as imagens de ambientes

    if (this.enabled) {

      //Iniciar o canvas do simulador
      this.stage = new Simulator();

      console.log('enabled', this.preparedOptions.enviroType)
      if (this.preparedOptions.enviroType) {
        this.enviroType = this.enviroTypes.filter(enviro => {
          console.log('filter enviro', enviro)
          return enviro.id == this.preparedOptions.enviroType
        })[0]
        console.log('enviro', this.enviroType);
        await this.getEnviros(this.enviroType.id)
        //tem uma opção de texture?
        //   var result = this.enviros.filter(enviro => {
        //     console.log('enviro', enviro)
        //     return enviro.id == this.preparedOptions.enviro
        //   })
        //   console.log('found enviro', result)
        //   //setar a textura

        ///setar a primeira
        this.selectEnviro(this.enviros[0])


      }
      console.log('esta operacaoi 1')
      //Get Textures
      await this.getTextures()
      await this.getProducts({
        codpro: this.preparedOptions.codpro
      })
      await this.getFinishings(this.products[0])


      console.log('ese valor', this.texture)
      //tem uma opção de texture?
      if (this.preparedOptions.codpro) {
        console.log('setar a primeira textura', this.textures[0].file)
        this.selectTexture(this.textures[0])
        this.selectFinishing(this.finishings[0])
        //
        // var result = this.textures.filter(texture => {
        //   return texture.id == this.preparedOptions.texture
        // })
        //setar a textura

      }
      console.log('esta operacaoi 2')
      //Get Products

    }
    //Iniciar com props do objeto
    console.log('optionsss', this.preparedOptions)
    // this.prepareOptions()


    this.dragAndDropCapable = this.determineDragAndDropCapable()
    console.log('can drag and droo', this.dragAndDropCapable)
    if (this.dragAndDropCapable) {
      /*
        Listen to all of the drag events and bind an event listener to each
        for the fileform.
      */
      ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (evt) {

        /*
          For each event add an event listener that prevents the default action
          (opening the file in the browser) and stop the propagation of the event (so
          no other elements open the file in the browser)
        */
        this.$refs.fileform.addEventListener(evt, function (e) {
          e.preventDefault()
          e.stopPropagation()
        }.bind(this), false)
      }.bind(this))


      this.$refs.fileform.addEventListener('dragenter', function (e) {
        this.isDragging = true
        console.log('is Draging')
      }.bind(this))


      this.$refs.fileform.addEventListener('dragleave', function (e) {
        this.isDragging = false
        console.log('Drag LEave')
      }.bind(this))
      /*
        Add an event listener for drop to the form
      */
      this.$refs.fileform.addEventListener('drop', function (e) {
        this.isDragging = false
        console.log('drop', e.dataTransfer)

        this.updateBackgroundImage(e.dataTransfer.files[0])
      }.bind(this))
    }


    console.log("Simulator Component mounted.")
  },
  methods: {
    setCarouselSwiping(state) {
      this.swiping = state;
    },
    //quando seleciono o tipo de ambiente
    selectEnviroType: function (enviroType) {
      console.log('select envirto type', enviroType)
      this.enviroType = enviroType
      //pegar as fotos
      this.getEnviros(enviroType.id)
    },
    //quando seleciono a foto do ambiente
    selectEnviro: function (enviro) {
      console.log('select enviro', enviro)
      this.enviro = enviro
      //trocar a imagem
      this.backgroundImagePath = enviro.file;
      console.log('finishing actual', this.finishing)
      console.log('product actuval actual', this.finishing)
      //proximo passo
      this.step = 2

      this.stage.setAmbiente(this.backgroundImagePath);
      //pegar produtos para esse tipo de aplicação
      this.getProducts({
        enviroType: this.enviroType.id
      })
    },

    clickOnContainer: function () {
      if (!this.enabled)
        window.location.href = '/simulador'
    },
    async getEnviros(enviroType) {
      this.enviros = [];
      await axios.get('/simulador/enviros/' + enviroType, {}).then((response) => {
        console.log('get simulador enviros', response.data)
        this.enviros = response.data
        this.step = 1
      })
    },
    async getTextures() {
      console.log('get Textures')
      await axios.get('/simulador/textures', {}).then((response) => {
        console.log('get simulador textures', response.data)
        this.textures = response.data
        this.refreshTextures++

      })
    },
    async getProducts(productParams) {
      console.log('get Products')
      //colocando aqui um parametro extra do tipo de ambiente/ INTERNO /; EXTERNO
      await axios.get('/simulador/products', {
        params: productParams
      }).then((response) => {
        console.log('get simulador products', response.data)
        this.products = response.data
        //tem uma opção de texture?

      })
    },

    async getFinishings(product) {
      await axios.get('/simulador/finishings/' + product.usu_modelo, {
        params: {
          enviroType: this.enviroType ? this.enviroType.id : null
        }
      }).then((response) => {
        console.log('get simulador finishings', response.data)
        this.finishings = response.data


      })
    },

    // //m€etodo para montar uma cena com parametros vindo da url
    // prepareOptions: function () {
    //   //tem uma textura?
    //   console.log('params', this.$route)
    //
    // },
    onResizeHandler: function (e) {

      console.log('tesete', e.target.outerHeight)
      console.log('tesete', e.target.outerWidth)
      this.screenWidth = e.target.outerWidth
      this.screenHeight = e.target.outerHeight

      this.doorSize.width = (388 * this.screenWidth) / 533
      this.doorSize.height = this.screenHeight
      // this.doorSize.right = (-10 * this.screenWidth) / 533
    },
    selectTexture(texture) {
      console.log('select texture', texture)
      this.step = 3
      this.texture = texture
      this.textureImagePath = this.texture.file

      console.log(this.texture.file, this.stage)

      this.stage.setTextura(this.texture.file)
    },
    selectProduct(product) {
      console.log('selectProduct', product)
      this.step = 4
      this.product = product

      this.getFinishings(this.product)


    },
    selectFinishing(finishing) {
      console.log('finishing', finishing)
      this.finishing = finishing
      this.step = 5
      var mascara = '/assets/upload/products/shadow/' + this.finishing.mask
      var macaneta = '/assets/upload/products/img_large/' + this.finishing.file
      this.stage.setMacaneta(mascara, macaneta)
      this.stage.setTexto(this.finishing.usu_modelo, this.finishing.acab_descricao, this.finishing.codpro)
    },
    goToStep(step) {
      if (!this.enabled) {
        return true
      }
      this.step = step
      if (step !== 1 && this.backgroundImagePath === null) {
        this.backgroundImagePath = 'images/ambiente-simulador.png'
      }
      if (step === 2) {
        this
      }
    },
    determineDragAndDropCapable() {
      /*
        Create a test element to see if certain events
        are present that let us do drag and drop.
      */
      var div = document.createElement('div')

      /*
        Check to see if the `draggable` event is in the element
        or the `ondragstart` and `ondrop` events are in the element. If
        they are, then we have what we need for dragging and dropping files.

        We also check to see if the window has `FormData` and `FileReader` objects
        present so we can do our AJAX uploading
      */
      return (('draggable' in div)
        || ('ondragstart' in div && 'ondrop' in div))
        && 'FormData' in window
        && 'FileReader' in window
    },
    backgroundWillChange: function () {
      console.log('will change')
    },
    onBackgroundChange: function (image) {
      console.log('emite', image)
    },
    uploadEnviroImage: function () {
      console.log('upload image');
      document.getElementById('uploadFileInput').click();
    },
    updateBackgroundImage: function (imageFile) {
      console.log('imageFIle ', imageFile)
      let reader = new FileReader()

      if (imageFile.type.includes("image/")) {
        reader.readAsDataURL(imageFile)
        reader.onload = e => {

          this.backgroundImagePath = e.target.result
          this.step = 2
          this.stage.setAmbiente(this.backgroundImagePath)
        }
      }
    },
    uploadImage: function (e) {
      if (typeof FileReader !== "function") {
        throw new TypeError('FileReader error')
      }

      // console.log('e', e)
      const imageFile = e.target.files[0]
      this.updateBackgroundImage(imageFile)
    },
    saveImageOnServer: async function (callback, print = false) {
      var formData = {
        catalogImage: print ? this.stage.goPrint() : this.stage.toDataURL(),

        filename: this.getFilename()
      }
      let response = await axios.post('/simulador/custom-image', formData)
      return callback(response)

    },
    buildCatalog: async function () {
      console.log('build catalog', this.product)
      await this.saveImageOnServer((response) => {
        console.log('response custom image', response)
        window.open('/crie-seu-catalogo/build?product_id=' + this.product.id + '&custom=1', '_blank')
      })


      //montar a imagem e enviar como url?
      // this.generateCanvas().then(canvas => {
      //   document.body.appendChild(canvas)
      //   console.log('canvass', canvas)
      //
      //   var download = function (product) {
      //     var formData = {
      //       catalogImage: canvas.toDataURL()
      //     }
      //     // canvas.remove()
      //     //salvar na sessao a imagem
      //     axios.post('simulador/custom-image/', formData).then((response) => {
      //       console.log('response custom image', response)
      //       window.open('/crie-seu-catalogo/build?product_id=' + product.id + '&custom=1', '_blank')
      //     });
      //
      //
      //     //
      //
      //   }
      //   download(this.product)
      //
      // })

    },
    generateCanvas: async function () {

      return html2canvas(document.querySelector(".simule-container"), {
        useCORS: true,

        onclone: function (document) {
          computedStyleToInlineStyle(document.querySelector(".simule-container"), {
            recursive: true,
            // properties: [
            //   'background-image', 'width', 'height', '-webkit-mask-size', 'mask-size', '-webkit-mask-image',
            //   'mask-image', 'right', 'position', 'background-size', 'background-position', 'background-blend-mode',
            //   'background-repeat', 'z-index', 'display', 'mix-blend-mode'
            // ]
          })
        }
      })
    },
    getFilename: function () {
      return 'IMAB_' + this.finishing.usu_modelo + '_' + this.enviroType.name + '_' + this.texture.name + '_' + moment().format('x') + '.png'
    },
    saveAsImage: async function () {
      console.log('save as image')

      var filename = this.getFilename()

      var download = function (canvas, filename) {
        console.log('canvas', canvas)
        var link = document.createElement('a')
        link.download = filename
        link.href = canvas.goPrint()
        console.log('link', link)
        link.click()
        link.remove()
      }
      download(this.stage, filename)


      // this.generateCanvas().then(canvas => {
      //   document.body.appendChild(canvas)
      //   console.log('canvass', canvas)
      //
      //   var download = function () {
      //     console.log('canvas', canvas)
      //     var link = document.createElement('a')
      //     link.download = 'imab.png'
      //     link.href = canvas.toDataURL()
      //     console.log('link', link)
      //     link.click()
      //     link.remove()
      //     canvas.remove()
      //
      //   }
      //   download()
      //
      // })


    },
    copyLink: async function () {

      try {
        await navigator.clipboard.writeText(this.shareUrl)
        console.log('Page URL copied to clipboard')
        toastr.success('Link copiado para a área de transferência')
      } catch (err) {
        console.error('Failed to copy: ', err)
      }

    },
    getShareLink: function () {
      //@TODO: O LINK DEVE SER PARA A IMAgEM QUE FOI MONTADA
      //montar o link de compartilhamento


      var url = window.location.protocol + '//' + window.location.hostname + window.location.pathname
      var params = {}
      if (this.texture) {
        params.texture = this.texture.id
      }

      if (this.product) {
        params.product = this.product.id
      }

      if (this.finishing) {
        params.finishing = this.finishing.id
      }

      if (this.enviroType) {
        params.enviroType = this.enviroType.id
      }

      if (this.enviro) {
        params.enviro = this.enviro.id
      }

      const queryParams = new URLSearchParams(params)


      return url + '?' + queryParams

    },
    shareLink: async function () {

      await this.saveImageOnServer((response) => {
        console.log('response', response.data)
        this.shareUrl = response.data.url
      }, true)

      //abrir um modal
      var myModal = new bootstrap.Modal(document.getElementById('shareModal'), {})
      myModal.show()
    }
  }


}

</script>
